module.exports = __webpack_public_path__ + "img/productBgImg9.0390aaf2.png";